// @flow
import {CATEGORY} from 'constants/actions';
import type {ActionType} from 'constants/flow/flowTypes';

/**
 * Get page number
 *
 * @param {number} state - Current page number
 * @param {ActionType<number>} action - Received data
 * @returns {number} New page number
 */
export default function numPage(state: number = 1, action: ActionType<number>): number {
    switch (action.type) {
        case CATEGORY.SET_PAGE_NUMBER:
            return action.payload;
        default:
            return state;
    }
}
